module.exports = __webpack_public_path__ + "img/pp4.9f630f48.png";